import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { loginRoutes } from '@mnz-modules/login/login-routes';

export const routes: Routes = [...loginRoutes, { path: '**', redirectTo: '/' }];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false, useHash: false, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
